import i18n from "i18next";
import { initReactI18next, I18nextProvider, useTranslation } from "react-i18next";

import nl from "@/config/locales/nl-NL.json";
import en from "@/config/locales/en-EN.json";

void i18n.use(initReactI18next).init({
  lng: "nl",
  resources: {
    nl: { translation: nl },
    en: { translation: en },
  },
  debug: false,
  interpolation: {
    escapeValue: false,
  },
});

export { I18nextProvider, useTranslation };
export { useLocale, useLocaleDebugControls } from "@/lib/locale/locale-context";
export default i18n;
